<template>
  <svg fill="none" height="18" viewBox="0 0 18 18" width="18">
    <path
      d="M9 2V16M2 9H16"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
  </svg>
</template>

<script>
  export default {
    name: 'PlusIcon',
  };
</script>
